// @ts-nocheck
import * as React from "react"
import * as ReactDom from "react-dom"
import DetalleBlog from "../components/views/DetalleBlog";
import { requestPageData } from "../services/api";
import { checkLang, setCurrentPage } from "../services/general";

export const page = async () => {
	const articleContainer = document.getElementById('detailBlog')
	const articleInfo = window.drupalSettings.react.node || await requestPageData({ content: "article", nid: articleContainer.dataset.nid, langcode: checkLang() })
	ReactDom.render(<DetalleBlog data={articleInfo} />, articleContainer)
	setBtnIcons()
	setCurrentPage('')
}

function setBtnIcons() {
	const refIcons = document.getElementById('shares-icons')
	const refNewIcons = document.getElementById('redes-share')

	refNewIcons.insertAdjacentElement('beforeend', refIcons.children[0])
	refIcons.remove()
}